export enum AttachmentsTabViews {
  TableView = 'TABLE_VIEW',
  GridView = 'GRID_VIEW',
}
